
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[_network]/protocol",
      function () {
        return require("private-next-pages/[_network]/protocol/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[_network]/protocol"])
      });
    }
  